import styled from 'styled-components';
import { DISPLAY_SIZE, ONE_HEADER_HEIGHT } from '../global.style.constants';

const device = {
  desktop: `(min-width:${DISPLAY_SIZE.DESKTOP})`,
  largeDesktop: `(min-width:${DISPLAY_SIZE.LARGE_DESKTOP})`,
  smallDesktop: `(min-width:${DISPLAY_SIZE.SMALL_DESKTOP})`,
  mobile: `(max-width:${DISPLAY_SIZE.MOBILE})`,
  tablet: `(min-width: ${DISPLAY_SIZE.TABLET})`,
  smallTablet: `(max-width: ${DISPLAY_SIZE.TABLET})`,
};

interface Props {
  desktopImg: string;
  mobileImg: string;
  isDesktop?: boolean;
}

export const TwoClickConsentWrapper = styled.div<Props>`
  background-blend-mode: darken;
  background-color: rgba(0, 0, 0, 0.7);
  background-image: ${(props) => `url(${props.mobileImg})`};
  background-position: inherit;
  background-size: cover;
  height: ${(props) => (props.isDesktop ? `calc(100vh - ${ONE_HEADER_HEIGHT})` : 'auto')};
  max-width: ${DISPLAY_SIZE.LARGE_DESKTOP};
  min-height: ${(props) => (props.isDesktop ? '0' : '70vh')};
  max-height: ${(props) => props.isDesktop && '1080px'};
  overflow: hidden;
  position: relative;
  width: 100%;

  @media ${device.tablet} {
    background-image: ${(props) => `url(${props.desktopImg})`};
  }
`;

export const MapToggleContainer = styled.div`
  align-items: baseline;
  background-color: #f2f2f2;
  bottom: 40px;
  column-gap: 19px;
  display: grid;
  padding: 23px 28px 28px 28px;

  p {
    padding: 16px 0 0;
    max-width: 284px;
  }

  .revoke-consent {
    align-self: center;
    color: #4c4c4c;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    letter-spacing: -0.015em;
    line-height: 167%;
    padding: 0;
  }
  .revoke-consent-label {
    align-self: center;
    font-size: 12px;
    font-style: normal;
    letter-spacing: -0.015em;
    line-height: 167%;
    padding: 0;
  }

  @media ${device.smallTablet} {
    bottom: unset;
    padding: 21px 30px;
    width: auto;
    z-index: 40;

    .revoke-consent {
      align-self: center;
      color: #4c4c4c;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      letter-spacing: -0.015em;
      line-height: 167%;
      padding: 0;
    }
    .revoke-consent-label {
      align-self: center;
      font-size: 12px;
      font-style: normal;
      letter-spacing: -0.015em;
      line-height: 167%;
      padding: 0;
    }
  }
`;
